import DataActionType from './data.types';
import AuthActionType from '../auth/auth.types';
import type { DataAction, DataLoadSuccessPayload } from './data.action';
import type { Bootstrap } from '../../api/httpTismsApi';
import type { Dccb, Branch } from '../../data/tisms-api';

export interface DataState {
  bootstrap: Bootstrap | null;
  dccbs: Dccb[];
  branches: Branch[];
  loading: boolean;
  error: string | null;
  loaded: boolean;
}

const INITIAL_STATE: DataState = {
  bootstrap: null,
  dccbs: [],
  branches: [],
  loading: false,
  error: null,
  loaded: false,
};

/* NB: this slice is NOT persisted (see root-reducer whitelist). It is re-fetched
   after login / on boot while a session exists, and cleared on logout so the
   next session pulls fresh reference data. */
export default (state: DataState = INITIAL_STATE, action: DataAction | { type: string }): DataState => {
  switch (action.type) {
    case DataActionType.DATA_LOAD_START:
      return { ...state, loading: true, error: null };
    case DataActionType.DATA_LOAD_SUCCESS: {
      const { bootstrap, dccbs, branches } = (action as DataAction & {
        payload: DataLoadSuccessPayload;
      }).payload;
      return { ...state, bootstrap, dccbs, branches, loading: false, error: null, loaded: true };
    }
    case DataActionType.DATA_LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: (action as { payload?: string }).payload ?? 'Failed to load reference data',
      };
    case DataActionType.DATA_RESET:
    case AuthActionType.AUTH_LOGOUT:
    case AuthActionType.AUTH_LOGIN_RESET:
      return INITIAL_STATE;
    default:
      return state;
  }
};
